import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CompanyService } from '@services/company.service';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
import CompanyV2Header from './CompanyV2Header';
import ClaimGroupListForCompanyOverview from './ClaimGroupListForCompanyOverview';
import CompletedClaimGroupCard from './CompletedClaimGroupCard';
import { sortByDateFieldDesc } from '@rd-web-markets/shared/dist/util/date/dateUtils';
import { useSetCompanyBreadcrumb } from '@rd-web-markets/shared/dist/util/hooks/useSetCompanyBreadcrumb';

const CompanyOverviewPage = ({ accountType }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(false);
  const [company] = CompanyService.useGet({ companyId: id, setLoading });
  useSetCompanyBreadcrumb(company, accountType);

  if (!company) return <Loading />;

  const claimGroups = company.claim_groups || [];

  const activeClaimGroups = claimGroups
    .filter((cg) => !cg.report_completion)
    .sort(sortByDateFieldDesc('to_date'));

  const completedClaimGroups = claimGroups;

  return (
    <>
      <CompanyV2Header company={company} accountType={accountType} activeTab="overview" />

      <div style={{ maxWidth: '95%', margin: '0 auto', padding: '1.5rem 3rem 2rem' }}>

        {activeClaimGroups.map((cg) => (
          <ClaimGroupListForCompanyOverview
            key={cg.id}
            claimGroups={[cg]}
            company={company}
            accountType={accountType}
          />
        ))}
        {completedClaimGroups.length > 0 && <hr className="my-4" />}

        {completedClaimGroups.length > 0 && (
          <>
            <h5
              className="text-primary fw-bold mb-3 text-uppercase"
              style={{ fontSize: '0.8rem', letterSpacing: '0.1em' }}
            >
              {t('completed_claims') || 'Completed Claims'}
            </h5>

            {completedClaimGroups.map((cg) => {
              return (
                <CompletedClaimGroupCard
                  key={cg.id}
                  claimGroup={cg}
                  company={company}
                  accountType={accountType}
                />
              );
            })}
          </>
        )}
      </div>
    </>
  );
};

export default CompanyOverviewPage;
